import { render, staticRenderFns } from "./DocumentByProComponent.vue?vue&type=template&id=5532c51b&"
import script from "./DocumentByProComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentByProComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports